import type { ReactElement } from 'react'
import { Calendar, Search } from 'lucide-react'
import { cn } from '@/lib/utils'

export type SearchLinkState = 0 | 1 | 2

interface SearchLinkToggleProps {
  state: SearchLinkState
  onChange: (next: SearchLinkState) => void
  className?: string
}

const TITLES: Record<SearchLinkState, string> = {
  0: 'Search and months are independent — click to link search',
  1: 'Search is linked between columns — click to also link months',
  2: 'Search and months are linked between columns — click to unlink',
}

export function SearchLinkToggle({
  state,
  onChange,
  className,
}: SearchLinkToggleProps): ReactElement {
  const next = ((state + 1) % 3) as SearchLinkState

  return (
    <button
      type="button"
      onClick={() => onChange(next)}
      title={TITLES[state]}
      aria-label={TITLES[state]}
      className={cn(
        'flex h-11 w-9 flex-col items-center justify-center gap-1 rounded-lg border bg-card shadow-sm transition-colors',
        state === 0
          ? 'border-border/70 hover:border-border'
          : 'border-foreground/35 hover:border-foreground/55',
        className,
      )}
    >
      <Search
        className={cn(
          'size-3 transition-colors',
          state >= 1 ? 'text-foreground' : 'text-muted-foreground/40',
        )}
      />
      <Calendar
        className={cn(
          'size-3 transition-colors',
          state >= 2 ? 'text-foreground' : 'text-muted-foreground/40',
        )}
      />
    </button>
  )
}
